import { CompanySettingsController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Accounting target settings.
 * @example
 * ```html
 * <salaxy-accounting-target-settings></salaxy-accounting-target-settings>
 * ```
 */

export class AccountingTargetSettings extends ComponentBase {

  /**
   * The following component properties (attributes in HTML) are bound to the Controller.
   * For detailed functionality, refer to [controller](#controller) implementation.
   */
  public bindings = {
    /** Forced read only state */
    isReadOnlyForced: "<"
  };

  /** Uses the CompanySettingsController */
  public controller = CompanySettingsController;

  /** Default template is the view  */
  public defaultTemplate = "salaxy-components/settings/AccountingTargetSettings.html";

}
